'use strict'

module.exports = {
 'title': 'NRL Rookie Dossier 2025',
 'name': 'NRLrookieDossier2025',
 'assetPath': {
  'development': 'https://nca1030283/nnd/',
  'staging': 'https://d2n6ofw4o746cn.cloudfront.net/nnd/data/tester/',
  'production': 'https://d2n6ofw4o746cn.cloudfront.net/nnd/'
 },
 'deployPath': {
  'development': '../../../nnd/',
  'staging': '../../tester/',
  'production': '../../nnd/'
 }
}



//////////////////
// WEBPACK FOOTER
// ./project.js
// module id = wrBJ
// module chunks = 0